<template>
  <div class="custom-input radio row">
    <fa v-if="faClass" :fa-class="faClass" />

    <div class="input-inner">
      <div v-if="label" :class="getLabelClass">
        {{ $t(label) }}
      </div>

      <div class="option-wrapper">
        <span v-for="(option, index) in opts" :key="option.id" class="option">
            <input type="radio"
                   :name="name"
                   :value="option.value"
                   :checked="option.selected"
                   @change="updateSelected(option)"
                   :required="required"
                   :id="name+index"
                   :class="{ 'undisplay-shadow' : !submitted }"
            />
            <label :for="name+index">
              <span v-if="option.label">{{ $t(option.label) }}</span>
              <span v-else-if="option.text">{{ $t(option.text) }}</span>
            </label>
        </span>
      </div>
    </div>

    <error v-if="displayError">
      {{ errorMessage }}
    </error>
  </div>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import bFormGroup from 'bootstrap-vue/es/components/form-group/form-group'
import bFormRadioGroup from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import bFormRadio from 'bootstrap-vue/es/components/form-radio/form-radio'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import error from '@/components/frontoffice/form/error'

export default {
  components: {
    fa,
    bFormGroup,
    bFormRadioGroup,
    bFormRadio,
    error
  },

  mixins: [formMethods],

  props: {
    faClass: String,
    label: String,
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default () {
        return [
          { value: 'yes', label: '_yes', selected: false },
          { value: 'no', label: '_no', selected: false }
        ]
      }
    },
    required: {
      type: Boolean,
      default: true
    },
    submitted: {
      type: Boolean,
      default: true
    },
    val: [Array, String, Number]
  },

  data () {
    return {
      displayError: false,
      errorMessage: '',
      opts: this.options
    }
  },

  created() {
    if (this.val) {
      this.opts.map(opt => {
        if (opt.value === this.val) opt.selected = true
      })
    }
  },

  methods: {
    updateSelected (selectedOption) {
      this.$emit('input', selectedOption.value)
    }
  }
}
</script>
